import React, {useEffect, useState} from "react";
import {mrbgStore} from "./mrbgRedux";

function MrbgSvgDefs({formStyle}){

  const
    [hasChart,setHasChart] = useState(mrbgStore.getState().HAS_CHART);

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setHasChart( mrbgStore.getState().HAS_CHART )
    });
    return () =>unsubscribe();
  },[]);

  if( !hasChart )
    return '';

  return(
    <div className={formStyle.svgDefsFrame}>
      <svg>
        <defs>
          <filter id="SCPFOuterShadow" filterUnits="userSpaceOnUse" width="200%" height="200%" x="-50%" y="-50%">
            <feFlood id="SCPFOuterShadow1" floodColor="#000000" floodOpacity="0.35" result="SCPFOuterShadow1Out" in="SourceGraphic"></feFlood>
            <feComposite id="SCPFOuterShadow2" in="SCPFOuterShadow1Out" in2="SourceAlpha" operator="in" result="SCPFOuterShadow2Out"></feComposite>
            <feOffset id="SCPFOuterShadow3" dx="0" dy="-3" result="SCPFOuterShadow3Out" in="SCPFOuterShadow2Out"></feOffset>
            <feGaussianBlur id="SCPFOuterShadow5" stdDeviation="4 " result="SCPFOuterShadow5Out" in="SCPFOuterShadow3Out"></feGaussianBlur>
            <feMerge id="SCPFOuterShadow4" result="SCPFOuterShadow4Out" in="SourceGraphic">
              <feMergeNode id="SCPFOuterShadow6" in="SCPFOuterShadow5Out"></feMergeNode>
              <feMergeNode id="SCPFOuterShadow7" in="[object Arguments]"></feMergeNode>
            </feMerge>
            <feBlend id="SvgjsFeBlend1024" in="SourceGraphic" in2="SCPFOuterShadow4Out" mode="normal" result="SvgjsFeBlend1024Out"></feBlend>
          </filter>
          <filter id="CSInnerShadow" filterUnits="userSpaceOnUse" width="200%" height="200%" x="-50%" y="-50%">
            <feFlood id="CSInnerShadow2" floodColor="#000000" floodOpacity="0.15" result="CSInnerShadow2Out" in="SourceGraphic"></feFlood>
            <feComposite id="CSInnerShadow3" in="CSInnerShadow2Out" in2="SourceAlpha" operator="in" result="CSInnerShadow3Out"></feComposite>
            <feOffset id="CSInnerShadow4" dx="0" dy="-3" result="CSInnerShadow4Out" in="CSInnerShadow3Out"></feOffset>
            <feGaussianBlur id="CSInnerShadow5" stdDeviation="4" result="CSInnerShadow5Out" in="CSInnerShadow4Out"></feGaussianBlur>
            <feMerge id="CSInnerShadow6" result="CSInnerShadow6Out" in="SourceGraphic">
              <feMergeNode id="CSInnerShadow7" in="CSInnerShadow5Out"></feMergeNode>
              <feMergeNode id="CSInnerShadow8" in="[object Arguments]"></feMergeNode>
            </feMerge>
            <feBlend id="SvgjsFeBlend1086" in="SourceGraphic" in2="CSInnerShadow6Out" mode="normal" result="SvgjsFeBlend1086Out"></feBlend>
          </filter>
          <linearGradient id="CSlinearGradient" x1="0" y1="1" x2="1" y2="1">
            <stop offset="0" stopOpacity="1" stopColor="#4C8EFA"></stop>
            <stop offset=".2" stopOpacity="1" stopColor="#3BB4D6"></stop>
            <stop offset=".8" stopOpacity="1" stopColor="#00FF3F"></stop>
            <stop offset="1" stopOpacity="1" stopColor="#00FF3F"></stop>
          </linearGradient>
        </defs>
      </svg>
      <svg>
        <defs>
          <linearGradient id="LClinearGradient" gradientTransform="rotate(90)">
            <stop offset="0" stopColor="#3765ce"></stop>
            <stop offset="1" stopColor="#4C8EFA"></stop>
          </linearGradient>
          <linearGradient id="LCShadow" gradientTransform="rotate(90)">
            <stop offset="0%" stopColor="#4C8EFA" stopOpacity=".4"></stop>
            <stop offset="100%" stopColor="#4C8EFA" stopOpacity="0.05"></stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
}
export default MrbgSvgDefs